import React, { useEffect, useState, useRef } from "react";
// import "./user.css";
import { CiEdit } from "react-icons/ci";
import { MdRemoveRedEye } from "react-icons/md";
import {
  disablePayinPayout,
  fetchAllProviders,
  getAlllRoles,
  getAllUsers,
  UpdateAutoSwitch,
  updateUser,
  UpdateAutoSwitchPayout,
  updateIpWhitelistStatus,
  updateUserStatus,
  updateVpaStatus,
  updatevalidateEmailStatus,
} from "../../config/LiveApi";
import Prompt from "../../components/common/Prompt";
import { toast } from "react-toastify";
import Modal from "./Modal";
import ViewModal from "./ViewModal";
import { Switch } from "@mui/material";
import { useSelector } from "react-redux";
import ConfirmModal from "./ConfirmaModal";
import { FaFilter } from "react-icons/fa";
import DataTable from "../../components/common/DataTable/DataTable";

function UserManageTable({
  isLoading,
  tableData,
  setTableData,
  onUpdateTableData,
  fetchUsers,
  payinChecked,
  payoutChecked,
  setPayinChecked,
  setPayoutChecked,
}) {
  const [isEnableUserPromptOpen, setIsEnableUserPromptOpen] = useState(false);
  const [isDisableUserPromptOpen, setIsDisableUserPromptOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [formData, setFormData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disableAllUserPayinPrompt, setDisableAllUserPayinPrompt] =
    useState(false);
  const [enableAllUserPayinPrompt, setEnableAllUserPayinPrompt] =
    useState(false);
  const [disableAllUserPayoutPrompt, setDisableAllUserPayoutPrompt] =
    useState(false);
  const [enableAllUserPayoutPrompt, setEnableAllUserPayoutPrompt] =
    useState(false);
  const [disableAllUsersPrompt, setDisableAllUsersPrompt] = useState(false);
  const [enableAllUsersPrompt, setEnableAllUsersPrompt] = useState(false);
  const role = useSelector((store) => store.userReducer.role);
  const token = useSelector((store) => store.userReducer.token);
  const currentUserId = useSelector((store) => store.userReducer.userId);
  const [providerOptions, setProviderOptions] = useState([]);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmText, setConfirmText] = useState("");
  const [roles, setRoles] = useState(false);
  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedRoleName, setSelectedRoleName] = useState("All");

  // Infinite scroll states
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const tableDivRef = useRef(null);

  // Fetch paginated users
  const fetchMoreUsers = async (pageNum, reset = false) => {
    setIsFetching(true);
    try {
      // Replace with your actual API endpoint and token if needed
      const response = await getAllUsers(token, pageNum);
      const result = response;
      if (result.data && result.data.length > 0) {
        setTableData((prev) => [...prev, ...result.data]);
        setHasMore(
          result.meta.pagination.page < result.meta.pagination.totalPages
        );
      } else {
        setHasMore(false);
      }
    } catch (err) {
      setHasMore(false);
    }
    setIsFetching(false);
  };

  // Scroll handler
  const handleScroll = () => {
    const div = tableDivRef.current;
    if (!div || isFetching || !hasMore) return;
    if (div.scrollTop + div.clientHeight >= div.scrollHeight - 100) {
      setPage((prev) => prev + 1);
    }
  };

  // Attach scroll event
  useEffect(() => {
    const div = tableDivRef.current;
    if (!div) return;
    div.addEventListener("scroll", handleScroll);
    return () => div.removeEventListener("scroll", handleScroll);
  }, [isFetching, hasMore]);

  // Fetch more users when page changes
  useEffect(() => {
    if (page === 1 || role === "admin" || role === "subAdmin") return;
    fetchMoreUsers(page);
    // eslint-disable-next-line
  }, [page]);

  // Reset infinite scroll on filter/role change
  useEffect(() => {
    setPage(1);
    setHasMore(true);
  }, [selectedRoleName]);

  const handleConfirmModal = (text, action) => {
    setConfirmText(text);
    setConfirmAction(() => action);
    setConfirmModalOpen(true);
  };

  const confirmAndClose = () => {
    if (confirmAction) confirmAction();
    setConfirmModalOpen(false);
  };

  const handleDisableAction = async (currentUser, fetchUsers) => {
    try {
      // await patch(`/v1/admin/users/${currentUser?.id}`, {
      //   status: currentUser.status,
      // });
      // onUpdateTableData((prevTableData) =>
      //   prevTableData.map((user) =>
      //     user.id === currentUser.id ? { ...user, ...formData } : user
      //   )
      // );
      // let action = "";
      // if (currentUser.status === 0) action = "User disabled";
      // if (currentUser.status === 2) action = "Payin disabled";
      // if (currentUser.status === 3) action = "Payout disabled";
      // toast.success(`${action} successfully.`);
      // setIsDisableUserPromptOpen(false);
      // fetchUsers();
    } catch (error) {
      console.log(error.message);
      toast.error("Unable to perform the action. Please try again.");
    }
  };

  const handleEnableAction = async (currentUser, fetchUsers) => {
    try {
      // await patch(`/v1/admin/users/${currentUser?.id}`, { status: 1 });
      // onUpdateTableData((prevTableData) =>
      //   prevTableData.map((user) =>
      //     user.id === currentUser.id ? { ...user, ...formData } : user
      //   )
      // );
      // let action = "";
      // if (currentUser.status === 0) action = "User enabled";
      // if (currentUser.status === 2) action = "Payin enabled";
      // if (currentUser.status === 3) action = "Payout enabled";
      // toast.success(`${action} successfully.`);
      // setIsEnableUserPromptOpen(false);
      // fetchUsers();
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleUpdateSubmit = async (updatedFormData, currentUser) => {
    event.preventDefault();

    try {
      await updateUser(token, updatedFormData);

      onUpdateTableData((prevTableData) =>
        prevTableData.map((user) =>
          user.id === currentUser.id ? { ...user, ...updatedFormData } : user
        )
      );

      toast.success("User updated successfully.");
      setIsModalOpen(false);
    } catch (error) {
      console.log(error.message);
      toast.error("Not able to update user. Please try again.");
    }
  };

  const updateFunction = (item, setFormData) => {
    setFormData(item);
    setIsModalOpen(true);
  };

  const viewFunction = (item, setFormData, setIsModalOpen) => {
    setFormData(item);
    setIsViewModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIsViewModalOpen(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleAllPayin = async (event) => {
    if (event.target.value == 1) setDisableAllUserPayinPrompt(true);
    else setEnableAllUserPayinPrompt(true);
  };

  const handleAllPayout = async (event) => {
    if (event.target.value == 1) setDisableAllUserPayoutPrompt(true);
    else setEnableAllUserPayoutPrompt(true);
  };

  const handleEnableAllPayinAction = async () => {
    await disablePayinPayout(token, {
      type: "PAYIN",
      action: "ENABLE",
    });

    setEnableAllUserPayinPrompt(false);
    setPayinChecked(!payinChecked);
  };

  const handleDisableAllPayinAction = async () => {
    await disablePayinPayout(token, {
      type: "PAYIN",
      action: "DISABLE",
    });

    setDisableAllUserPayinPrompt(false);
    setPayinChecked(!payinChecked);
  };

  const handleEnableAllPayoutAction = async () => {
    await disablePayinPayout(token, {
      type: "PAYOUT",
      action: "ENABLE",
    });

    setEnableAllUserPayoutPrompt(false);
    setPayoutChecked(!payoutChecked);
  };

  const handleDisableAllPayoutAction = async () => {
    await disablePayinPayout(token, {
      type: "PAYOUT",
      action: "DISABLE",
    });

    setDisableAllUserPayoutPrompt(false);
    setPayoutChecked(!payoutChecked);
  };

  const handleEnableAllAction = async () => {
    try {
      await disablePayinPayout(token, {
        status: 1,
      });
    } catch (err) {
      console.log(err.message);
      throw err;
    }

    setEnableAllUsersPrompt(false);
    // setUserChecked(!userChecked);
  };

  const handleDisableAllAction = async () => {
    try {
      await disablePayinPayout(token, {
        status: 0,
      });
    } catch (err) {
      console.log(err.message);
      throw err;
    }

    setDisableAllUsersPrompt(false);
    // setUserChecked(!userChecked);
  };

  const handlePayinChange = async (item) => {
    if (item.status === 0) {
      toast.info("User is diabled.");
      return;
    }
    let updatedStatus;

    if (item.status === 1) {
      // Active → disable payin
      updateUserStatus(token, item, 2);
      updatedStatus = 2;
      toast.success(`Payin disabled successfully.`);
    } else if (item.status === 2) {
      // Payin disabled → back to active
      updateUserStatus(token, item, 1);
      updatedStatus = 1;
      toast.success(`Payin enabled successfully.`);
    } else if (item.status === 3) {
      // Payout disabled → disable payin too → both off but user enabled
      updateUserStatus(token, item, 4);
      updatedStatus = 4;
      toast.success(`Both Payin & Payout disabled successfully.`);
    } else if (item.status === 4) {
      // Both disabled → re-enable payin (payout still disabled)
      updateUserStatus(token, item, 3);
      updatedStatus = 3;
      toast.success(`Payin enabled successfully.`);
    }

    setTableData((prevData) =>
      prevData.map((i) =>
        i.id === item.id ? { ...i, status: updatedStatus } : i
      )
    );
  };

  const handlePayoutChange = (item) => {
    if (item.status === 0) {
      toast.info("User is diabled.");
      return;
    }
    let updatedStatus;

    if (item.status === 1) {
      // Active → disable payout
      updateUserStatus(token, item, 3);
      updatedStatus = 3;
      toast.success(`Payout disabled successfully.`);
    } else if (item.status === 3) {
      // Payout disabled → back to active
      updateUserStatus(token, item, 1);
      updatedStatus = 1;
      toast.success(`Payout enabled successfully.`);
    } else if (item.status === 2) {
      // Payin disabled → disable payout too → both off but user enabled
      updateUserStatus(token, item, 4);
      updatedStatus = 4;
      toast.success(`Both Payin & Payout disabled successfully.`);
    } else if (item.status === 4) {
      // Both disabled → re-enable payout (payin still disabled)
      updateUserStatus(token, item, 2);
      updatedStatus = 2;
      toast.success(`Payout enabled successfully.`);
    }

    setTableData((prevData) =>
      prevData.map((i) =>
        i.id === item.id ? { ...i, status: updatedStatus } : i
      )
    );
  };

  const handleUserChange = (item) => {
    if (item.role === "super") {
      toast.warning("Super user cannot be disabled");
      return;
    } else if (item.id === currentUserId) {
      toast.warning("Current user cannot be disabled");
      return;
    }

    let updatedStatus;

    if (item.status === 0) {
      updateUserStatus(token, item, 4);
      updatedStatus = 4;
      toast.success(`User enabled successfully.`);
    } else {
      updateUserStatus(token, item, 0);
      updatedStatus = 0;
      toast.success(`User disabled successfully.`);
    }

    setTableData((prevData) =>
      prevData.map((i) =>
        i.id === item.id ? { ...i, status: updatedStatus } : i
      )
    );
  };

  useEffect(() => {
    if (role == "super" || role == "operation" || role == "subSuper") {
      const getProviders = async () => {
        const response = await fetchAllProviders(token);
        setProviderOptions(response.data.providers);
      };

      getProviders();
    }
  }, []);

  useEffect(() => {
    if (role == "super" || role == "operation" || role == "subSuper") {
      const fetchRoles = async () => {
        try {
          const response = await getAlllRoles(token);
          const roleData = response.data;
          setRoleOptions(roleData);
        } catch (err) {
          toast.error("Unable to fetch.");
        }
      };
      fetchRoles();
    }
  }, [token]);

  const filteredItems =
    tableData?.filter((item) => {
      const matchesRoleName =
        selectedRoleName === "All" || !selectedRoleName
          ? true
          : item.role === selectedRoleName;

      return matchesRoleName;
    }) ?? [];

  const handleVPAChange = (item) => {
    try {
      updateVpaStatus(token, item, !item.validateVpa);
      location.reload();
      toast.success("VPA Validation changed successfully.");
    } catch (err) {
      toast.error("VPA Validation could not be changed.");
      console.error(err.message);
    }
  };

  const handleValidateEmailChange = (item) => {
    try {
      updatevalidateEmailStatus(token, item, !item.validateEmail);
      location.reload();
      toast.success("Email Validation changed successfully.");
    } catch (err) {
      toast.error("Email Validation could not be changed.");
      console.error(err.message);
    }
  };

  const handleIPWhitelisting = (item) => {
    try {
      updateIpWhitelistStatus(token, item, !item.ipRequired);
      location.reload();
      toast.success("IP whitelisting status changed successfully.");
    } catch (err) {
      toast.error("IP whitelisting status could not be changed.");
      console.error(err.message);
    }
  };

  const handleAutoSwitch = (item) => {
    try {
      const updatedAutoSwitch = !item.autoSwitch;
      const payload = {
        id: item.id,
        autoSwitch: updatedAutoSwitch,
      };
      UpdateAutoSwitch(token, payload);
      setTableData((prevData) =>
        prevData.map((user) =>
          user.id === item.id
            ? { ...user, autoSwitch: updatedAutoSwitch }
            : user
        )
      );
      if (updatedAutoSwitch) {
        toast.success(
          `Auto Switch Enable for User ${
            item.role === "admin"
              ? item.alias || item.id
              : item.alias || item.name
          }.`
        );
      } else {
        toast.success(
          `Auto Switch Disable for  User ${
            item.role === "admin"
              ? item.alias || item.id
              : item.alias || item.name
          }.`
        );
      }
    } catch (err) {
      toast.error("Auto Switch could not be changed.");
      console.error(err.message);
    }
  };
  const handleAutoSwitchPayout = (item) => {
    try {
      const updatedAutoSwitch = !item.autoSwitchPayout;
      const payload = {
        id: item.id,
        autoSwitchPayout: updatedAutoSwitch,
      };
      UpdateAutoSwitchPayout(token, payload);
      setTableData((prevData) =>
        prevData.map((user) =>
          user.id === item.id
            ? { ...user, autoSwitchPayout: updatedAutoSwitch }
            : user
        )
      );
      if (updatedAutoSwitch) {
        toast.success(
          `Auto Switch Payout Enable for User ${
            item.role === "admin"
              ? item.alias || item.id
              : item.alias || item.name
          }.`
        );
      } else {
        toast.success(
          `Auto Switch Payout Disable for  User ${
            item.role === "admin"
              ? item.alias || item.id
              : item.alias || item.name
          }.`
        );
      }
    } catch (err) {
      toast.error("Auto Switch Payout could not be changed.");
      console.error(err.message);
    }
  };

  const rolePriority = {
    super: 1,
    subSuper: 2,
    admin: 3,
    operation: 4,
  };

  const columns = [
    {
      key: "serialNo",
      header: "S.No",
      render: (_, index) => index + 1,
    },

    {
      key: "email",
      header: "User Email",
    },

    {
      key: "name",
      header: "Name",
      render: (row) =>
        row.role === "admin" ? row.alias || row.id : row.alias || row.name,
    },

    ...(role === "super" || role === "operation" || role === "subSuper"
      ? [
          {
            key: "role",
            header: "Role",
            filterable: true,
            filterType: "menu",
            filterValue: selectedRoleName,
            filterOptions: [
              { label: "All", value: "All" },
              ...roleOptions.map((r) => ({
                label: r.role,
                value: r.role,
              })),
            ],
            onFilterChange: setSelectedRoleName,
            render: (row) => row.role,
          },
        ]
      : [
          {
            key: "role",
            header: "Role",
            render: (row) => row.role,
          },
        ]),

    ...(role !== "admin" && role !== "subAdmin"
      ? [
          {
            key: "payinProviderID",
            header: "Payin ProviderID",
            render: (row) => {
              const provider = providerOptions.find(
                (p) => p.id === row.payinProviderID,
              );

              return (
                <span
                  style={{
                    color: provider?.isActive ? "black" : "red",
                  }}
                >
                  {provider
                    ? `${provider.providerName} - ${provider.orgName}`
                    : "N/A"}
                </span>
              );
            },
          },

          {
            key: "payoutProviderID",
            header: "Payout ProviderID",
            render: (row) => {
              const provider = providerOptions.find(
                (p) => p.id === row.payoutProviderID,
              );

              return (
                <span
                  style={{
                    color: provider?.isActive ? "black" : "red",
                  }}
                >
                  {provider
                    ? `${provider.providerName} - ${provider.orgName}`
                    : "N/A"}
                </span>
              );
            },
          },

          {
            key: "payin",
            header: "Payin",
            render: (row) =>
              row.role !== "admin" && row.role !== "subAdmin" ? (
                "N/A"
              ) : (
                <Switch
                  checked={row.status === 1 || row.status === 3}
                  onChange={() =>
                    handleConfirmModal(
                      `Are you sure you want to ${
                        row.status === 1 || row.status === 3
                          ? "disable"
                          : "enable"
                      } payin for ${row.alias || row.id}?`,
                      () => handlePayinChange(row),
                    )
                  }
                />
              ),
          },

          {
            key: "payout",
            header: "Payout",
            render: (row) =>
              row.role !== "admin" && row.role !== "subAdmin" ? (
                "N/A"
              ) : (
                <Switch
                  checked={row.status === 1 || row.status === 2}
                  onChange={() =>
                    handleConfirmModal(
                      `Are you sure you want to ${
                        row.status === 1 || row.status === 2
                          ? "disable"
                          : "enable"
                      } payout for ${row.alias || row.name || row.id}?`,
                      () => handlePayoutChange(row),
                    )
                  }
                />
              ),
          },
        ]
      : []),

    {
      key: "user",
      header: "User",
      thProps: {
        "data-tour": "user-status",
      },
      render: (row) => (
        <Switch
          checked={row.status !== 0}
          onChange={() =>
            handleConfirmModal(
              `Are you sure you want to ${
                row.status !== 0 ? "disable" : "enable"
              } user ${row.alias || row.name || row.id}?`,
              () => handleUserChange(row),
            )
          }
        />
      ),
    },

    ...(role !== "admin" && role !== "subAdmin"
      ? [
          {
            key: "vpa",
            header: "VPA",
            render: (row) => (
              <Switch
                checked={row.validateVpa == 1}
                onChange={() =>
                  handleConfirmModal(
                    `Are you sure you want to ${
                      row.validateVpa != 1 ? "disable" : "enable"
                    } validate VPA?`,
                    () => handleVPAChange(row),
                  )
                }
              />
            ),
          },

          {
            key: "validateEmail",
            header: "Email",
            render: (row) => (
              <Switch
                checked={row.validateEmail == 1}
                onChange={() =>
                  handleConfirmModal(
                    `Are you sure you want to ${
                      row.validateEmail == 1 ? "disable" : "enable"
                    } validate Email?`,
                    () => handleValidateEmailChange(row),
                  )
                }
              />
            ),
          },

          {
            key: "ip",
            header: "IP",
            render: (row) => (
              <Switch
                checked={row.ipRequired == 1}
                onChange={() =>
                  handleConfirmModal(
                    `Are you sure you want to ${
                      row.ipRequired == 1 ? "disable" : "enable"
                    } IP Whitelisting?`,
                    () => handleIPWhitelisting(row),
                  )
                }
              />
            ),
          },

          {
            key: "autoSwitch",
            header: "Auto Switch Payin",
            wrapHeader: true,
            render: (row) => (
              <Switch
                checked={!!row.autoSwitch}
                onChange={() =>
                  handleConfirmModal(
                    `Are you sure you want to ${
                      row.autoSwitch ? "disable" : "enable"
                    } Auto Switch Payin?`,
                    () => handleAutoSwitch(row),
                  )
                }
              />
            ),
          },

          {
            key: "autoSwitchPayout",
            header: "Auto Switch Payout",
            wrapHeader: true,
            render: (row) => (
              <Switch
                checked={!!row.autoSwitchPayout}
                onChange={() =>
                  handleConfirmModal(
                    `Are you sure you want to ${
                      row.autoSwitchPayout ? "disable" : "enable"
                    } Auto Switch Payout?`,
                    () => handleAutoSwitchPayout(row),
                  )
                }
              />
            ),
          },
        ]
      : []),

    {
      key: "status",
      header: "Status",
      render: (row) => (
        <div className="user-table-head status-table">
          <span className={row.status === 0 ? "red-dot" : "green-dot"} />

          {row.status === 0 ? (
            <span className="inactive">Inactive</span>
          ) : row.status === 1 ? (
            <span className="active">Active</span>
          ) : row.status === 2 ? (
            <span className="active">Payin Disabled</span>
          ) : row.status === 3 ? (
            <span className="active">Payout Disabled</span>
          ) : row.status === 4 ? (
            role === "admin" || role === "subAdmin" ? (
              <span className="active">Active</span>
            ) : (
              <span className="active">Payin &amp; Payout Disabled</span>
            )
          ) : null}
        </div>
      ),
    },
    {
      key: "update",
      header: "Update",
      thProps: {
        "data-tour": "update-user",
      },
      render: (row) =>
        row.role !== "super" ? (
          <CiEdit
            style={{
              width: "1.2rem",
              height: "1.2rem",
              cursor: "pointer",
            }}
            onClick={() => updateFunction(row, setFormData)}
          />
        ) : null,
    },

    {
      key: "view",
      header: "View",
      thProps: {
        "data-tour": "view-user-details",
      },
      render: (row) => (
        <MdRemoveRedEye
          style={{
            width: "1.2rem",
            height: "1.2rem",
            cursor: "pointer",
          }}
          onClick={() => viewFunction(row, setFormData, setIsModalOpen)}
        />
      ),
    },
  ];

  return (
    <div data-tour="youre-all-set" className="main-div">
      {(role === "super" || role === "operation" || role === "subSuper") && (
        <div className="disable-header">
          <div className="disable-all">
            <button
              onClick={handleAllPayin}
              className="disable-all-btn"
              value={payinChecked ? 1 : 0}
              style={{
                backgroundColor: payinChecked ? "red" : "green",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              {payinChecked ? "Disable Payin" : "Enable Payin"}
            </button>
          </div>

          <div className="disable-all">
            <button
              onClick={handleAllPayout}
              className="disable-all-btn"
              value={payoutChecked ? 1 : 0}
              style={{
                backgroundColor: payoutChecked ? "red" : "green",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              {payoutChecked ? "Disable Payout" : "Enable Payout"}
            </button>
          </div>
        </div>
      )}

      <div
        data-tour="user-list"
        className="table-main-div"
        ref={tableDivRef}
        style={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <DataTable
          columns={columns}
          data={[...filteredItems].sort((a, b) => {
            const roleA = rolePriority[a.role] ?? 99;
            const roleB = rolePriority[b.role] ?? 99;
            return roleA - roleB;
          })}
          d
          loading={isLoading}
          emptyMessage="No Users Found"
        />
        {isModalOpen && (
          <Modal
            onClose={handleModalClose}
            onSubmit={(updatedFormData) => {
              handleUpdateSubmit(updatedFormData, formData);
            }}
            initialFormData={formData}
            isUpdating={true}
            isLoading={isLoading}
            role={role}
          />
        )}
        {confirmModalOpen && (
          <ConfirmModal
            text={confirmText}
            onConfirm={confirmAndClose}
            onCancel={() => setConfirmModalOpen(false)}
          />
        )}

        {isViewModalOpen && (
          <ViewModal onClose={handleModalClose} formData={formData} />
        )}
        {isEnableUserPromptOpen && (
          <Prompt
            open={() => setIsEnableUserPromptOpen(false)}
            onClose={() => setIsEnableUserPromptOpen(false)}
            onConfirm={() => handleEnableAction(formData, fetchUsers)}
            text={`Are you sure you want to ${
              formData.status === 2
                ? "enable payin"
                : formData.status === 3
                  ? "enable payout"
                  : "enable user"
            }: ${formData?.asdsad}?`}
          />
        )}
        {isDisableUserPromptOpen && (
          <Prompt
            open={() => setIsDisableUserPromptOpen(false)}
            onClose={() => setIsDisableUserPromptOpen(false)}
            onConfirm={() => handleDisableAction(formData, fetchUsers)}
            text={`Are you sure you want to ${
              formData.status === 2
                ? "disable payin"
                : formData.status === 3
                  ? "disable payout"
                  : "disable user"
            }: ${formData?.akjds}?`}
          />
        )}
        {disableAllUserPayinPrompt && (
          <Prompt
            open={() => setDisableAllUserPayinPrompt(false)}
            onClose={() => setDisableAllUserPayinPrompt(false)}
            onConfirm={() => handleDisableAllPayinAction(formData, fetchUsers)}
            text={"Are you sure you want to disable payin for all users?"}
          />
        )}
        {enableAllUserPayinPrompt && (
          <Prompt
            open={() => setEnableAllUserPayinPrompt(false)}
            onClose={() => setEnableAllUserPayinPrompt(false)}
            onConfirm={() => handleEnableAllPayinAction(formData, fetchUsers)}
            text={"Are you sure you want to enable payin for all users?"}
          />
        )}
        {disableAllUserPayoutPrompt && (
          <Prompt
            open={() => setDisableAllUserPayoutPrompt(false)}
            onClose={() => setDisableAllUserPayoutPrompt(false)}
            onConfirm={() => handleDisableAllPayoutAction(formData, fetchUsers)}
            text={"Are you sure you want to disable payout for all users?"}
          />
        )}

        {enableAllUserPayoutPrompt && (
          <Prompt
            open={() => setEnableAllUserPayoutPrompt(false)}
            onClose={() => setEnableAllUserPayoutPrompt(false)}
            onConfirm={() => handleEnableAllPayoutAction(formData, fetchUsers)}
            text={"Are you sure you want to enable payout for all users?"}
          />
        )}

        {disableAllUsersPrompt && (
          <Prompt
            open={() => setDisableAllUsersPrompt(false)}
            onClose={() => setDisableAllUsersPrompt(false)}
            onConfirm={() => handleDisableAllAction(formData, fetchUsers)}
            text={"Are you sure you want to disable all users?"}
          />
        )}

        {enableAllUsersPrompt && (
          <Prompt
            open={() => setEnableAllUsersPrompt(false)}
            onClose={() => setEnableAllUsersPrompt(false)}
            onConfirm={() => handleEnableAllAction(formData, fetchUsers)}
            text={"Are you sure you want to enable all users?"}
          />
        )}

        {isFetching && hasMore && (
          <div style={{ textAlign: "center", padding: "15px" }}>
            Loading more users...
          </div>
        )}
        {!hasMore && (
          <div style={{ textAlign: "center", padding: "15px" }}>
            No more users
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(UserManageTable);